<!-- Нижнее окно: выезд, свайп вниз, затемнение — SheetDirective -->
<div class="footer-dialog-container" [appSheet]="scrollContent" (sheetClosed)="onSheetClosed()">

  <!-- Ручка: окно закрывается свайпом вниз -->
  <div class="sheet-grabber"></div>

  <div mat-icon-button (click)="close(); $event.stopPropagation()" class="close-button">
    <mat-icon class="close-icon">close</mat-icon>
  </div>

  <div class="footer-dialog-title__header">
    <p>{{ 'сontacts' | translate }}</p>
  </div>

  <div class="footer-dialog-content" #scrollContent>
    <div class="footer-dialog-info">
      <p *ngIf="details?.title" class="info-title">{{ details.title }}</p>
      <p *ngIf="details?.inn">ИНН: {{ details.inn }}</p>
      <p *ngIf="details?.kpp">КПП: {{ details.kpp }}</p>
      <p *ngIf="details?.ogrn">ОГРН: {{ details.ogrn }}</p>
      <p *ngIf="details?.address">Адрес: {{ details.address }}</p>
      <p *ngIf="details?.phone">Телефон: {{ details.phone }}</p>
      <p *ngIf="details?.email">Email: {{ details.email }}</p>
    </div>

    <div class="footer-dialog-footer"></div>
  </div>
</div>
